import React, {useState} from "react";
import Cotizadortest from "../../Cotizardor/Cotizardortest";
import Dashboard from "../../Dasboard/Dashboard";
import { Loader } from "../../../Loader/Loader";


export const Cotizadorsol = (props) => {
  let [loading, setLoading] = useState(false);
  if (loading) {
    return <Loader />;
  }
  
  return (
    <>
      <Dashboard
        MInicio={""}
        Msolicitudes={""}
        Mservicios={""}
        Mcompra={props.Mcompra}
        Mcunyompra={props.Mcunyompra}
        Mempaquetar={""}
        Mcpotenciales={""}
        Madminportal={""}
        Mcampaña={""}
        Mtv={""}
      >
      <section className="home-section" style={{ margin: 1, padding: "1rem" }}>
        <Cotizadortest
          funcion={props.funcionExe}
          setLoading={setLoading}
          Loader={loading}
          onclickfun={"fun()"}
          ruta={"/Solicitud"}
          nombreButton={"Adquirir Plan"}
          displaycall={"none"}
        />
      </section>
      </Dashboard>
    </>
  );
};


// ## Summary
// The `Cotizadorsol` function is a React component that renders a dashboard and a section for a quotation form. It handles loading state and displays a loader component while fetching data.

// ## Example Usage
// ```javascript
// <Cotizadorsol Mcompra={Mcompra} Mcunyompra={Mcunyompra} funcionExe={funcionExe} />
// ```

// ## Code Analysis
// ### Inputs
// - `props`: An object containing the `Mcompra`, `Mcunyompra`, and `funcionExe` properties.
// ___
// ### Flow
// 1. The function receives the `props` object as input.
// 2. It initializes the `loading` state variable with a value of `false`.
// 3. If `loading` is `true`, it renders the `Loader` component.
// 4. It renders the `Dashboard` component with the appropriate props.
// 5. It renders the `Cotizadortest` component with the appropriate props.
// 6. When the `Cotizadortest` component calls the `setLoading` function, it updates the `loading` state variable.
// 7. The `Loader` component is rendered while the data is being fetched.
// 8. The `Cotizadorsol` component is rendered with the `Dashboard` and `Cotizadortest` components.
// ___
// ### Outputs
// - The rendered components.
// ___
